// extracted by mini-css-extract-plugin
export default {"navbarContainer":"navbar_navbarContainer__XPpFF","logo":"navbar_logo__fn2cn","sidebarToggle":"navbar_sidebarToggle__bsA77","searchbar":"navbar_searchbar__-+umc"};